import React from 'react';
import PlaygroundTab from './PlaygroundTab';

const PlaygroundPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Playground</h2>
        <p className="text-sm text-gray-600 mt-1">Test and interact with deployed models</p>
      </div>
      <PlaygroundTab />
    </div>
  );
};

export default PlaygroundPage;
